import React from 'react'
import CalendarBlackSvg from '../../../assets/icons/CalendarBlackSvg'
import PaperclipRedSvg from '../../../assets/icons/PaperclipRedSvg'
import PaperclipBlackSvg from '../../../assets/icons/PaperclipBlackSvg'
import DownloadWhiteSvg from '../../../assets/icons/DownloadWhiteSvg'

const NotificationItem = ({
  title,
  date,
  desc,
  detay,
  dividerVisible,
  adds = null,
}) => {
  const textLimit = (desc) => {
    return desc?.length >= 180 ? desc?.slice(0, 180) + '...' : desc
  }
  const downloadPDF = (pdfUrl, pdfName) => {
    // Dosyanın tam URL'sini oluştur
    // Eğer pdfUrl zaten tam URL ise bu kısım gerekli olmayabilir
    const fullUrl = pdfUrl.startsWith('http')
      ? pdfUrl
      : `https://your-api-domain.com/${pdfUrl}`

    const link = document.createElement('a')
    link.href = fullUrl
    link.setAttribute('download', '')

    if (pdfName) {
      link.setAttribute('download', pdfName)
    }

    document.body.appendChild(link)

    link.click()

    document.body.removeChild(link)
  }

  return (
    <div>
      <div className='notificationTitle'>{title}</div>
      <div className='notificationDate'>
        <div>
          <CalendarBlackSvg width={'1rem'} />
        </div>
        <div>{date}</div>
        {adds && !detay && (
          <div
            style={{
              display: 'flex',
              gap: '.28rem',
              margin: '0 0 0 .5rem',
            }}
          >
            <div>
              <PaperclipRedSvg width={'1rem'} />
            </div>
            <div>
              <div>{`${adds?.length} Ek İçeriyor`}</div>
            </div>
          </div>
        )}
      </div>
      <div className='notificationDesc'>{!detay ? textLimit(desc) : desc}</div>
      {dividerVisible && <div className='notificationDivider' />}
      {adds && detay && (
        <>
          <div style={{ margin: '0 0 .3rem 0' }}>Duyuru Ekleri</div>
          {adds?.map((item) => (
            <div key={item.id} style={{ display: 'flex', gap: '.2rem' }}>
              <div
                style={{
                  display: 'flex',
                  gap: '1rem',
                  width: '100%',
                  margin: '.2rem 0',
                  padding: '.5rem .5rem .5rem 1rem',
                  border: '1px solid #707070',
                  borderRadius: '8px',
                }}
              >
                <PaperclipBlackSvg width={'1rem'} />
                <div>{item.dosya_adi}</div>
              </div>
              <div
                onClick={() => downloadPDF(item.dosya_url, item.dosya_adi)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContents: 'center',
                  padding: '.5rem 1rem',
                  border: '3px solid #fff',
                  borderRadius: '8px',
                  backgroundColor: '#2FA826',
                }}
              >
                <DownloadWhiteSvg width={'1.3rem'} />
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  )
}

export default NotificationItem
